import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const LiveOddsWidgetAsyncComponent = AsyncComponent(async () => import('./live-odds-widget' /* webpackChunkName: "live-odds-widget" */ ));

export const LiveOddsWidgetAsync = (props) => {
  return <LiveOddsWidgetAsyncComponent {...props}/>
};
